/* eslint-disable import/order */
import { MenuIdDashboards } from '@jira/navigation-apps__constants/src/MenuIdDashboards.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { DASHBOARD } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { NORMAL_EARLY_ASSET_STRATEGY } from '@jira/platform__common-constants/src/ssr-early-assets.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { selectedDashboardRoute } from '@jira/router-routes__dashboard-routes/src/selectedDashboardRoute.tsx';
import { DashboardRedirect } from './ui/dashboard-redirect/index.tsx';
import { dashboardResources, LazyDashboardView } from './ui/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const selectedDashboardRouteEntry: Route = createEntry(selectedDashboardRoute, () => ({
	group: 'dashboard',
	// eslint-disable-next-line no-restricted-syntax
	component: DashboardRedirect,
	layout: globalLayout,

	navigation: {
		menuId: MenuIdDashboards,
	},

	resources: [...getNavigationResources(), ...dashboardResources()],
	forPaint: [LazyAtlassianNavigation, LazyDashboardView],

	meta: {
		capability: DASHBOARD,
	},

	isRedirect: true,
	earlyAssets: NORMAL_EARLY_ASSET_STRATEGY,
	wrmMode: 'early',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
